module.exports = __webpack_public_path__ + "img/Project-3.fec3c15.jpg";